// AI token packs sold on Shopify (one-time purchase, no selling plan). Variant
// ids + token grants mirror TOKEN_PACK_VARIANTS in supabase/functions/
// shopify-webhook (which credits the tokens on `orders/paid`). Prices are for
// display only; Shopify is the source of truth at checkout.

export type TokenPack = {
  variantId: string;
  name: string;
  tokens: number;
  price: string;
  /** Optional "best value" flag for the picker UI. */
  featured?: boolean;
};

export const TOKEN_PACKS: TokenPack[] = [
  { variantId: "51967440650560", name: "Starter", tokens: 400, price: "$4.99" },
  { variantId: "51967440683328", name: "Creator", tokens: 1000, price: "$9.99" },
  { variantId: "51967440716096", name: "Pro", tokens: 2500, price: "$19.99", featured: true },
  { variantId: "51967440748864", name: "Studio", tokens: 6000, price: "$49.99" },
];

// Allow-list used server-side so the checkout endpoint can only mint carts for a
// real token pack, never an arbitrary variant id.
export const TOKEN_PACK_VARIANT_IDS = new Set(TOKEN_PACKS.map((pack) => pack.variantId));
